import eventInvitation from '@/api/event-invitation'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
	...baseState,
	ac_status_id: 1,
	ac_year_id: undefined,
	invitation_subject_id: undefined,
	date_from: moment()
		.add(-1, 'Month')
		.format('DD-MM-YYYY'),
	date_to: moment()
		.format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_DATE_FROM(state, data) {
		state.date_from = data
	},
	SET_DATE_TO(state, data) {
		state.date_to = data
	},
	SET_YEAR_ID(state, data) {
		state.ac_year_id = data
	},
	SET_INVITATION_SUBJECT_ID(state, data) {
		state.invitation_subject_id = data
	},
	SET_AC_STATUS(state, acStatusId) {
		state.ac_status_id = acStatusId
	}
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				search: context.state.search,
				ac_year_id: context.state.ac_year_id,
				invitation_subject_id: context.state.invitation_subject_id,
				date_range: [context.state.date_from, context.state.date_to]
			},
			attrubutes
		)
		return eventInvitation.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return eventInvitation.store(data)
	},
	update(context, data) {
		return eventInvitation.update(data)
	},
	destroy(context, id) {
		return eventInvitation.destroy(id)
	},
	getInvitationSubject(context, data) {
		return eventInvitation.invitationSubject(data)
	},
	previewPdf(context, data) {
		return eventInvitation.previewPdf({
			params: {
				id: data.id,
				invitation_id: data.invitation_id
			}
		})
	},
	getEventVenue(context, data) {
		return eventInvitation.eventVenue(data)
	},
}
